
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";

import Profile1 from "assets/img/team/profile-picture-1.jpg"
import Profile2 from "assets/img/team/profile-picture-2.jpg"
import Profile3 from "assets/img/team/profile-picture-3.jpg"
import Profile4 from "assets/img/team/profile-picture-4.jpg"

export default [
    {
        "id": uuidv4(),
        "read": false,
        "favorite": false,
        "image": Profile1,
        "sender": "Roy Fendley",
        "timeSent": "11:01 AM",
        "message": "lets do it"
    },
    {
        "id": uuidv4(),
        "read": false,
        "favorite": true,
        "image": Profile3,
        "sender": "Bonnie Green",
        "timeSent": "10:23 AM",
        "message": "Benefits !"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": true,
        "sender": "Scott Anderson",
        "timeSent": "10:01 AM",
        "message": "Value Creation"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": false,
        "image": Profile4,
        "sender": "Ronnie Buchanan",
        "timeSent": "07:45 AM",
        "message": "Finance Stream"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": false,
        "image": Profile3,
        "sender": "Jane Rinehart",
        "timeSent": "07:30 AM",
        "message": "HR Stream"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": false,
        "sender": "William Ginther",
        "timeSent": "06:10 AM",
        "message": "IT Stream"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": false,
        "image": Profile2,
        "sender": "George Driskell",
        "timeSent": moment().subtract(5,"days").format("MMM DD"),
        "message": "Automation Stream "
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": false,
        "image": Profile4,
        "sender": "Ronnie Buchanan",
        "timeSent": moment().subtract(7,"days").format("MMM DD"),
        "message": "Innovation Stream"
    },
    {
        "id": uuidv4(),
        "read": true,
        "favorite": true,
        "sender": "Jane Rinehart",
        "timeSent": moment().subtract(8,"days").format("MMM DD"),
        "message": "Integration Stream"
    }
]